import { connect } from 'react-redux';
import { online } from '../../../../../../core/selectors/live';
import ConversationParticipant from './ConversationParticipant';

const mapStateToProps = (state, ownProps) => {
  const { participantId: userId } = ownProps;
  const cachedUser = state.data.users[userId];
  return {
    name: cachedUser ? `${cachedUser.firstName} ${cachedUser.lastName}` : '',
    avatar: cachedUser ? cachedUser.avatar : null,
    online: online(state, userId),
  };
};

const mapDispatchToProps = () => ({});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ConversationParticipant);
